import React from 'react';
import {
  string,
  number,
  bool,
} from 'prop-types';
import _ from 'lodash';
import './ProgressBar.scss';

const Filler = (props) => {
  const { percentage, barColor, barBorderColor } = props;
  const tempBarBorderColor = barBorderColor !== '' ? `1px solid ${barBorderColor}` : '';
  return <div className="filler" style={{ width: `${percentage}%`, border: `${tempBarBorderColor}`, backgroundColor: `${barColor}` }} />;
};

Filler.propTypes = {
  percentage: number.isRequired,
  barColor: string.isRequired,
  barBorderColor: string.isRequired,
};

const ProgressBarTitle = (props) => {
  const {
    title,
    stepText,
    barStepTitleColor,
    progressBarShowsOnlyTitle,
  } = props;
  return (
    <div className="progress-bar-row">
      <div className="progress-bar-title-wrapper" style={{ color: `${barStepTitleColor}` }}>
        {title}
      </div>
      { !progressBarShowsOnlyTitle && <div className="progress-bar-step-wrapper">{stepText}</div> }
    </div>
  );
};

ProgressBarTitle.propTypes = {
  title: string,
  stepText: string,
  barStepTitleColor: string,
  progressBarShowsOnlyTitle: bool,
};

ProgressBarTitle.defaultProps = {
  title: '',
  stepText: '',
  barStepTitleColor: '',
  progressBarShowsOnlyTitle: null,
};

const ProgressBarWrapper = (props) => {
  const {
    percentage,
    barColor,
    barBorderColor,
    barBkColor,
    barBkBorderColor,
    barHeight,
  } = props;
  const tempBarBkBorderColor = barBkBorderColor !== '' ? `1px solid ${barBkBorderColor}` : '';
  return (
    <div
      className="progress-bar"
      style={{
        border: `${tempBarBkBorderColor}`,
        backgroundColor: `${barBkColor}`,
        height: `${barHeight}px`,
      }}
    >
      <Filler percentage={percentage} barColor={barColor} barBorderColor={barBorderColor} />
    </div>
  );
};

ProgressBarWrapper.propTypes = {
  percentage: number.isRequired,
  barColor: string.isRequired,
  barBorderColor: string.isRequired,
  barBkColor: string.isRequired,
  barBkBorderColor: string.isRequired,
  barHeight: number.isRequired,
};

const ProgressBar = ({
  barStepTitleColor,
  barColor,
  barBorderColor,
  barBkColor,
  barBkBorderColor,
  stepNow,
  allStep,
  barHeight,
  title,
  stepTextTemplate,
  progressBarShowsOnlyTitle,
}) => {
  const percentage = stepNow / allStep * 100 > 100 ? 100 : stepNow / allStep * 100;
  const stepText = _.template(stepTextTemplate)({
    stepNow,
    allStep,
  });
  return (
    <div className="progress-bar-wrapper">
      <ProgressBarTitle
        title={title}
        stepText={stepText}
        barStepTitleColor={barStepTitleColor}
        progressBarShowsOnlyTitle={progressBarShowsOnlyTitle}
      />
      {
      !progressBarShowsOnlyTitle && (
      <ProgressBarWrapper
        percentage={percentage}
        barColor={barColor}
        barBorderColor={barBorderColor}
        barBkColor={barBkColor}
        barBkBorderColor={barBkBorderColor}
        barHeight={barHeight}
        title={title}
        stepText={stepText}
      />
      )}
    </div>
  );
};

ProgressBar.propTypes = {
  barStepTitleColor: string,
  barColor: string,
  barBorderColor: string,
  barBkColor: string,
  barBkBorderColor: string,
  stepNow: string,
  allStep: number,
  barHeight: number,
  title: string,
  stepTextTemplate: string,
  progressBarShowsOnlyTitle: bool,
};

ProgressBar.defaultProps = {
  barStepTitleColor: '#77AA43',
  barColor: '#77AA43',
  barBorderColor: '',
  barBkColor: '#E6E6E6',
  barBkBorderColor: '',
  stepNow: 0,
  allStep: 100,
  barHeight: 6,
  title: '',
  stepTextTemplate: '',
  progressBarShowsOnlyTitle: null,
};

export default ProgressBar;
